import { render, staticRenderFns } from "./CompMst.vue?vue&type=template&id=1bafbdbe&"
import script from "./CompMst.vue?vue&type=script&lang=js&"
export * from "./CompMst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports